import React from 'react';
import './GraphCard.scss';

const GraphCard = ({ title, children, height = 400, legendItems = [] }) => {
  return (
    <div className="graph-card">
      {title && (
        <div className="graph-card-header">
          <h5>{title}</h5>
          {legendItems.length > 0 && (
            <div className="graph-card-legend">
              {legendItems.map((item, index) => (
                <div key={index} className="legend-item">
                  <div
                    className="legend-color"
                    style={{ backgroundColor: item.color }}
                  />
                  <span className="legend-label">{item.label}</span>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
      <div className="graph-card-body" style={{ height: `${height}px` }}>
        {children}
      </div>
    </div>
  );
};

export default GraphCard;
